export const CONSOLE_SOUNDS = [
  {
    name: "DING_DONG",
    src: require("@/assets/audio/DING_DONG_DING.mp3"),
  },
  {
    name: "RED_ALERT",
    src: require("@/assets/audio/RED_ALERT.mp3"),
  },
  {
    name: "NUCLEAR",
    src: require("@/assets/audio/NUCLEAR.mp3"),
  },
  {
    name: "TWILIGHT",
    src: require("@/assets/audio/TWILIGHT.mp3"),
  },
];
